'use strict';

import Area from '../../common/area';

function Room (object, dictionary) {
  /** @var Area|null Общая площадь */
  this.totalArea = object.get('squareTotal') ? new Area('общая', object.get('squareTotal')) : null;

  /** @var Area|null Жилая площадь */
  this.livingArea = object.get('squareLiving') ? new Area('жилая', object.get('squareLiving')) : null;

  /** @var Area|null "Площадь кухни" */
  this.kitchenArea = object.get('squareKitchen') ? new Area('кухня', object.get('squareKitchen')) : null;

  /** @var Map|null Сан.узел */
  this.sanitary = dictionary.getSanitary(object.get('sanitaryId')) || null;

  /** @var Map|null Тип планировки */
  this.planning = dictionary.getPlanning(object.get('planningId')) || null;

  /** @var Renovation|null Тип состояния/ремонта */
  this.renovation = dictionary.getRenovation(object.get('renovationTypeId')) || null;

  /** @var OuterDoor|null Тип входной двери */
  this.outerDoorType = dictionary.getDoorType(object.get('outerDoorTypeId')) || null;

  /** @var FloorCovering|null Тип полового покрытия */
  this.floorCovering = dictionary.getFloorCovering(object.get('floorCoveringId')) || null;

  /** @var Balcony|null Тип балкона */
  this.balcony = dictionary.getBalcony(object.get('balconyId')) || null;

  /** @var Windows|null Тип окна */
  this.windowType = dictionary.getWindowType(object.get('windowTypeId')) || null;

  /** @var WindowsView|null Тип вида из окна */
  this.windowView = dictionary.getWindowView(object.get('windowViewId')) || null;

  /** @var Furniture|null Тип наличия мебели */
  this.furniture = dictionary.getFurniture(object.get('furnitureId')) || null;

  /** @var int|null Количество комнат */
  // this.roomsNumber = null;

  /** @var int|null Этаж */
  this.floorNumber = object.get('floor', null);

  /** @var bool|null Наличие отдельного входа */
  this.privateEntrance = object.get('ownEntrance', null);

  /** @var int|null Количество спальных мест */
  this.numberOfBeds = object.get('numberOfBeds', null);

  /** @var int|null Высота потолков */
  this.ceilingHeight = object.get('ceilingHeight', null);

  /** @var bool|null Является ли помещение угловым (угловая квартира) */
  this.corner = object.get('isCorner', null);

  /** @var bool|null Наличие телефона */
  this.phone = object.get('hasPhone', null);

  /** @var bool|null Наличие холодильника */
  this.fridge = object.get('hasFridge', null);

  /** @var bool|null Наличие телевизора */
  this.TV = object.get('hasTV', null);

  /** @var bool|null Наличие стиральной машины */
  this.washingMachine = object.get('hasWashingMachine', null);

  /** @var bool|null Наличие кондиционера воздуха */
  this.conditioner = object.get('hasConditioning', null);

  /** @var bool|null Наличие интернета */
  this.internet = object.get('hasInternet', null);

  /** @var bool|null Наличие счетчика воды */
  this.waterMeter = object.get('hasAquacount', null);
}

Room.prototype.getTotalArea = function () {
  return this.totalArea;
};

Room.prototype.getLivingArea = function () {
  return this.livingArea;
};

Room.prototype.getKitchenArea = function () {
  return this.kitchenArea;
};

Room.prototype.getSanitary = function () {
  return this.sanitary;
};

Room.prototype.getPlanning = function () {
  return this.planning;
};

Room.prototype.getRenovation = function () {
  return this.renovation;
};

Room.prototype.getFloorCovering = function () {
  return this.floorCovering;
};

Room.prototype.getOuterDoorType = function () {
  return this.outerDoorType;
};

Room.prototype.isCorner = function () {
  return this.corner;
};

Room.prototype.getCeilingHeight = function () {
  return this.ceilingHeight;
};

Room.prototype.getBalcony = function () {
  return this.balcony;
};

Room.prototype.getFloorNumber = function () {
  return this.floorNumber;
};

Room.prototype.isPrivateEntrance = function () {
  return this.privateEntrance;
};
Room.prototype.getLabelPrivateEntrance = function () {
  return this.isPrivateEntrance() ? 'отд.\u00A0вход' : '';
};

Room.prototype.getWindowView = function () {
  return this.windowView;
};

Room.prototype.getWindowType = function () {
  return this.windowType;
};

Room.prototype.getFurniture = function () {
  return this.furniture;
};

Room.prototype.hasPhone = function () {
  return this.phone;
};
Room.prototype.getLabelPhone = function () {
  return this.hasPhone() ? 'телефон' : '';
};

Room.prototype.hasFridge = function () {
  return this.fridge;
};
Room.prototype.getLabelFridge = function () {
  return this.hasFridge() ? 'холодильник' : '';
};

Room.prototype.hasTV = function () {
  return this.TV;
};
Room.prototype.getLabelTV = function () {
  return this.hasTV() ? 'ТВ' : '';
};

Room.prototype.hasWashingMachine = function () {
  return this.washingMachine;
};

Room.prototype.getLabelWashingMachine = function () {
  return this.hasWashingMachine() ? 'стир.\u00A0маш.' : '';
};

Room.prototype.getNumberOfBeds = function () {
  return this.numberOfBeds;
};
Room.prototype.getLabelNumberOfBeds = function () {
  return this.getNumberOfBeds() ? 'спальн.\u00A0мест\u00A0-\u00A0' + this.getNumberOfBeds() : '';
};

Room.prototype.hasConditioning = function () {
  return this.conditioner;
};

Room.prototype.getLabelConditioning = function () {
  return this.hasConditioning() ? 'кондиц-ер' : '';
};

Room.prototype.hasInternet = function () {
  return this.internet;
};

Room.prototype.hasWaterMeter = function () {
  return this.waterMeter;
};

export default Room;



// WEBPACK FOOTER //
// ./src/classes/announcement/property/room.js